module.exports = "/assets/data/b52ba1b39b0604cc9f86430eeba318f2-B32.data.json";